import {LANGUAGE} from '@/common/utils/constants';

export const GLOBAL_SEARCH_SECTIONS = {
	[LANGUAGE.en.short]: {
		stories: "stories",
		showAll: "Show all",
		cancel: "Cancel",
		tools: "tools",
		certifications: 'certifications',
		top5Projects: 'Latest projects',
		noMatch: "We couldn't find anything matching your search.",
		companies: "clients",
		referenceOwners: "Reference owners",
		businessContactManagers: "Business Managers",
		deliveryContactManagers: "Delivery Managers",
		offers: "Offers",
		projects: 'Projects',
		suggestions: 'Suggestions by',
		latestProjects: 'Latest projects',
		projectTextContentMatch: 'Projects\' text content match',
		clientNameMatch: 'Clients\' name match',
		toolMatch: 'Tools match',
		certificateMatch: 'Certifications match',
		ownerMatch: 'Reference owner match',
		businessManagerMatch: 'Business Contact Manager match',
		deliveryManagerMatch: 'Delivery Contact Manager match',
		searchPlaceholder: "Start typing and press Enter to see all stories",
		relatedOfferMatch: 'Related offers match'
	},
	[LANGUAGE.it.short]: {
		stories: "storie",
		showAll: "Mostra tutto",
		cancel: "Annulla",
		tools: "Strumenti",
		certifications: 'certificazioni',
		top5Projects: 'Ultimi progetti',
		noMatch: 'Non siamo riusciti a trovare nulla che corrisponda alla tua ricerca.',
		companies: "clienti",
		referenceOwners: "Proprietari di riferimento",
		businessContactManagers: "Dirigenti d'impresa",
		deliveryContactManagers: "Responsabili delle consegne",
		offers: "offerte",
		projects: 'Progetti',
		suggestions: 'Suggerimenti di',
		latestProjects: 'Ultimi progetti',
		projectTextContentMatch: 'Corrispondenza del contenuto testuale dei progetti',
		clientNameMatch: 'Corrispondenza dei nomi dei clienti',
		toolMatch: 'Gli strumenti corrispondono',
		certificateMatch: 'Le certificazioni corrispondono',
		ownerMatch: 'Corrispondenza del proprietario di riferimento',
		businessManagerMatch: 'Corrispondenza di Business Contact Manager',
		deliveryManagerMatch: 'Corrispondenza del Delivery Contact Manager',
		searchPlaceholder: 'Inizia a digitare e premi invio per vedere tutte le storie',
		relatedOfferMatch: 'Offerte correlate corrispondono'
	},
	[LANGUAGE.de.short]: {
		stories: "Geschichten",
		showAll: "Zeige alles",
		cancel: "Absagen",
		tools: "Werkzeug",
		certifications: 'Zertifizierungen',
		top5Projects: 'Neueste Projekte',
		noMatch: 'Wir konnten nichts passendes zu Ihrer Suche finden.',
		companies: "Kunden",
		referenceOwners: "Referenzinhaber",
		businessContactManagers: "Unternehmensleiter",
		deliveryContactManagers: "Liefermanager",
		offers: "bietet an",
		projects: 'Projekte',
		suggestions: 'Vorschläge von',
		latestProjects: 'Neue Projekte',
		projectTextContentMatch: 'Textinhalt der Projekte stimmt überein',
		clientNameMatch: 'Übereinstimmung der Kundennamen',
		toolMatch: 'Werkzeuge passen',
		certificateMatch: 'Zertifizierungen stimmen überein',
		ownerMatch: 'Übereinstimmung mit dem Referenzbesitzer',
		businessManagerMatch: 'Übereinstimmung mit Business Contact Manager',
		deliveryManagerMatch: 'Corrispondenza del Delivery Contact Manager',
		searchPlaceholder: 'Beginnen Sie mit der Eingabe und drücken Sie die Eingabetaste, um alle Storys anzuzeigen',
		relatedOfferMatch: 'Ähnliche Angebote passen'
	},
	[LANGUAGE.fr.short]: {
		stories: "histoires",
		showAll: "Afficher tout",
		cancel: "Annuler",
		tools: "outils",
		certifications: 'certifications',
		top5Projects: 'Dernier projets',
		noMatch: 'Nous n\'avons rien trouvé correspondant à votre recherche.',
		companies: "clients",
		referenceOwners: "Propriétaires de référence",
		businessContactManagers: "Business managers",
		deliveryContactManagers: "Delivery managers",
		offers: "des offres",
		projects: 'Projets',
		suggestions: 'Suggestions de',
		latestProjects: 'Derniers projets',
		projectTextContentMatch: 'Correspondance du contenu textuel des projets',
		clientNameMatch: 'Correspondance des noms des clients',
		toolMatch: 'Les outils correspondent',
		certificateMatch: 'Les certifications correspondent',
		ownerMatch: 'Correspondance du propriétaire de référence',
		businessManagerMatch: 'Correspondance avec le gestionnaire de contacts professionnels',
		deliveryManagerMatch: 'Correspondance du gestionnaire de contacts de livraison',
		searchPlaceholder: 'Commencez à taper et appuyez sur Entrée pour voir toutes les histoires',
		relatedOfferMatch: 'Offres similaires correspondantes'
	},
	[LANGUAGE.ja.short]: {
		stories: "物語",
		showAll: "すべて表示する",
		cancel: "キャンセル",
		tools: "ツール",
		certifications: '認証',
		top5Projects: '最新のプロジェクト',
		noMatch: '検索に一致するものが見つかりませんでした。',
		companies: "クライアント",
		referenceOwners: "参照所有者",
		businessContactManagers: "ビジネスマネージャー",
		deliveryContactManagers: "デリバリーマネージャー",
		offers: "オファー",
		projects: 'プロジェクト',
		suggestions: '提案者',
		latestProjects: '最新のプロジェクト',
		projectTextContentMatch: 'プロジェクトのテキスト内容の一致',
		clientNameMatch: 'クライアントの名前の一致',
		toolMatch: 'ツールの一致',
		certificateMatch: '認証が一致',
		ownerMatch: '参照所有者の一致',
		businessManagerMatch: 'ビジネスコンタクトマネージャーの一致',
		deliveryManagerMatch: '配送担当者とのマッチング',
		searchPlaceholder: '入力を開始してEnterキーを押すとすべてのストーリーが表示されます',
		relatedOfferMatch: '関連オファーが一致'
	},
	[LANGUAGE.es.short]: {
		stories: "historias",
		showAll: "Mostrar todo",
		cancel: "Cancelar",
		tools: "herramientas",
		certifications: 'certificaciones',
		top5Projects: 'Últimos proyectos',
		noMatch: 'No hemos encontrado nada que coincida con tu búsqueda.',
		companies: "clientes",
		referenceOwners: "Propietarios de referencia",
		businessContactManagers: "Gerentes de contacto comercial",
		deliveryContactManagers: "Gerentes de contacto de entrega",
		offers: "ofertas",
		projects: 'Proyectos',
		suggestions: 'Sugerencias de',
		latestProjects: 'Últimos proyectos',
		projectTextContentMatch: 'Coincidencia del contenido de texto del proyecto',
		clientNameMatch: 'Coincidencia del nombre del cliente',
		toolMatch: 'Coincidencia de herramientas',
		certificateMatch: 'Coincidencia de certificaciones',
		ownerMatch: 'Coincidencia del propietario de referencia',
		businessManagerMatch: 'Coincidencia del gerente de contacto comercial',
		deliveryManagerMatch: 'Coincidencia del gerente de contacto de entrega',
		searchPlaceholder: 'Comienza a escribir y presiona Enter para ver todas las historias',
		relatedOfferMatch: 'Coincidencia de ofertas relacionadas'
	}
}
